export const CLASS_PROFILE_DROPDOWN = 'profile-dropdown';

export enum EProfileUserWhere {
    NAVPANEL = 'NAVPANEL',
    PROFILE = 'PROFILE',
}
